'use client'; // Error boundaries must be Client Components

import React from 'react';
import ErrorPageModule from '@/modules/error';

export default function Error() {
  return (
    <div className="bg-white h-full">
      <ErrorPageModule statusCode={500} />
    </div>
  );
}
